import { useAuth } from "./AuthProvider";

export function usePermissions() {
  const { permissions } = useAuth();

  return {
    hasPermission: (code: string) => permissions.includes(code),
    hasAnyPermission: (codes: string[]) =>
      codes.some((code) => permissions.includes(code)),
    hasAllPermissions: (codes: string[]) =>
      codes.every((code) => permissions.includes(code)),
    permissions,
  };
}
